import ReactDOM from 'react-dom/client';
import { FirebaseAppProvider } from 'reactfire';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

const target = import.meta.env.VITE_BUILD_TARGET;

// Register service worker for PWA support (flossi target only)
if (target === 'flossi') {
  import('./serviceWorkerRegistration').then((sw) => sw.register());
}

// Force a unique compilation fingerprint per GitHub deployment run to break Firebase preview cache
if (import.meta.env.DEV) {
  console.debug("Build fingerprint is:", import.meta.env.VITE_BUILD_VERSION);
}

const importBuildTarget = async () => {
  if (target === "flossi") {
    return await import('./App');
  } else if (target === "stmarys") {
    return await import('./stmarys/StMarysApp');
  } else if (target === "chippingfc") {
    return await import('./chippingfc/ChippingFCApp');
  } else if (target === "flossi-api") {
    return await import('./flossi-api/FlossiApiApp');
  } else if (target === "flossi-admin") {
    return await import('./flossi-admin/FlossiAdminApp');
  } else {
    return Promise.reject(
      new Error("No such build target: " + target)
    );
  }
}

importBuildTarget().then(({ default: Environment }) => {
  root.render(
    <FirebaseAppProvider firebaseConfig={firebaseConfig}>
      <Environment />
    </FirebaseAppProvider>
  );
})